import React from 'react';
import {
  Router,
  Switch,
  Route,
} from "react-router-dom";
import Authenticated from './components/authenticated';
import Home from './pages/home';
import Catalog from './pages/catalog';
import Davidsons from './pages/davidsons';
import Rsr from './pages/rsr';
import SportsSouth from './pages/sports_south';
import Zanders from './pages/zanders';
import CatalogProduct from './pages/catalog_product';
import DavidsonsProduct from './pages/davidsons_product';
import RsrProduct from './pages/rsr_product';
import SportsSouthProduct from './pages/sports_south_product';
import ZandersProduct from './pages/zanders_product';
import LogIn from './pages/login';
import { getHistory } from './helpers/history';
import './styles/styles.scss';

const history = getHistory();

const App: React.FC = () => {
  return (
    <Router history={history}>
        <Switch>
          <Authenticated exact path="/">
            <Home />
          </Authenticated>
          <Route path="/login">
            <LogIn />
          </Route>
          <Authenticated path="/catalog/:id">
            <CatalogProduct />
          </Authenticated>
          <Authenticated path="/catalog">
            <Catalog />
          </Authenticated>
          <Authenticated path="/davidsons/:id">
            <DavidsonsProduct />
          </Authenticated>
          <Authenticated path="/davidsons">
            <Davidsons />
          </Authenticated>
          <Authenticated path="/rsr/:id">
            <RsrProduct />
          </Authenticated>
          <Authenticated path="/rsr">
            <Rsr />
          </Authenticated>
          <Authenticated path="/sports-south/:id">
            <SportsSouthProduct />
          </Authenticated>
          <Authenticated path="/sports-south">
            <SportsSouth />
          </Authenticated>
          <Authenticated path="/zanders/:id">
            <ZandersProduct />
          </Authenticated>
          <Authenticated path="/zanders">
            <Zanders />
          </Authenticated>
        </Switch>
    </Router>
  );
}

export default App;
